import {
  AppSelectComponent,
  GridSize,
  GridWrapperComponent,
  MultiRowSelection
} from 'common-components'
import { AfterContentInit, Component, Input, OnInit, ViewChild } from '@angular/core'
import { Option } from 'common-components'
import {
  LocationCoverageTypeODataService,
  LocationCoverageTypes
} from '@exchange/app/domain/system/locationCoverageType'
import { UtilService } from '@exchange/app/services/utilService'
import { IState } from '@tracker/app/domain'
import { IMarket, LocationCoverageStateInclusionODataService } from '@exchange/app/domain'
import { forkJoin } from 'rxjs'
import { ODataFunction } from 'common-services'

@Component({
  selector: 'app-market-edit-coverage',
  templateUrl: './market-edit-coverage.component.html',
  standalone: false
})
export class MarketEditCoverageComponent implements OnInit, AfterContentInit {
  @Input()
  model: IMarket = {} as IMarket

  @ViewChild('locationCoverageType', { static: true })
  locationCoverageTypeComponent: AppSelectComponent
  @ViewChild('available', { static: true })
  available: GridWrapperComponent
  @ViewChild('selected', { static: true })
  selected: GridWrapperComponent

  GridSize = GridSize
  private _gridOptions = {
    canEdit: false,
    canDelete: false
  }
  availableSelection: IState[] = []
  selectedSelection: IState[] = []

  locationCoverageTypeOptions: Option[] = []

  constructor(
    private locationCoverageTypeService: LocationCoverageTypeODataService,
    private locationCoverageStateInclusionService: LocationCoverageStateInclusionODataService,
    public util: UtilService
  ) {}

  ngOnInit(): void {
    this.locationCoverageTypeService
      .query()
      .exec()
      .subscribe(result => {
        this.locationCoverageTypeOptions = result.data.map(
          location => new Option(location.Id, location.Name, location)
        )

        if (this.model) {
          this.locationCoverageTypeComponent.active = this.model.LocationCoverageTypeId
            ? this.locationCoverageTypeOptions.filter(
                option => option.id === this.model.LocationCoverageTypeId
              )
            : []
        }
      })
  }

  ngAfterContentInit(): void {
    if (this.model) {
      this.initializeAvailable()
      this.initializeSelected()
    }
  }

  initializeAvailable() {
    this.available.gridOptions.context = this._gridOptions
    this.available.gridOptions.columnDefs = [
      {
        headerName: 'Id',
        field: 'Id',
        width: 50,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true, newRowsAction: 'keep' }
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.available.gridOptions.rowSelection = MultiRowSelection
    this.available.odata = this.locationCoverageStateInclusionService
    this.available.odataFunction = {
      key: null,
      name: `Default.GetMarketAvailableInclusions(marketId=${this.model.Id})`
    } as ODataFunction
    this.available.gridOptions.onSelectionChanged = this.recalculateSelected.bind(this)
  }

  initializeSelected() {
    this.selected.gridOptions.context = this._gridOptions
    this.selected.gridOptions.columnDefs = [
      {
        headerName: 'Id',
        field: 'Id',
        width: 50,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true, newRowsAction: 'keep' }
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.selected.gridOptions.rowSelection = MultiRowSelection
    this.selected.odata = this.locationCoverageStateInclusionService
    this.selected.odataFunction = {
      key: null,
      name: `Default.GetMarketSelectedInclusions(marketId=${this.model.Id})`
    } as ODataFunction
    this.selected.gridOptions.onSelectionChanged = this.recalculateSelected.bind(this)
  }

  recalculateSelected() {
    this.availableSelection = this.available.api.getSelectedRows() as IState[]
    this.selectedSelection = this.selected.api.getSelectedRows() as IState[]
  }

  select() {
    const observables = this.availableSelection.map(item =>
      this.locationCoverageStateInclusionService.customAction(
        this.model.Id,
        'Default.UpdateStateInclusions',
        {
          stateId: item.Id
        }
      )
    )

    forkJoin(observables).subscribe(_ => {
      this.selected.getData()
      this.available.getData()
      setTimeout(this.recalculateSelected.bind(this), 250)
    })
  }

  remove() {
    const observables = this.selectedSelection.map(item =>
      this.locationCoverageStateInclusionService.customAction(
        this.model.Id,
        'Default.UpdateStateInclusions',
        {
          stateId: item.Id
        }
      )
    )

    forkJoin(observables).subscribe(_ => {
      this.selected.getData()
      this.available.getData()
      setTimeout(this.recalculateSelected.bind(this), 250)
    })
  }

  locationTypeChanged = (option: any) => {
    // Re-pull data just in case something changed with the data
    if (option.id === LocationCoverageTypes.Distance) {
      this.selected.getData()
      this.available.getData()
    }
    this.model.LocationCoverageTypeId = option.id
  }

  locationTypeCleared() {
    this.model.LocationCoverageTypeId = null
  }

  distanceVisible() {
    return this.model.LocationCoverageTypeId === LocationCoverageTypes.Distance
  }
}
